/** Analytics agent routes: Audience, Audit & incidents, Reports (appended to the registry with one spread). */
import type { ConsoleRoute } from './index';
import {
  AudienceEngagementTab,
  AudienceExportsTab,
  AudiencePage,
  AudienceProfilesTab,
  AudienceSegmentsTab,
} from './audience/AudiencePage';
import { ParticipantProfilePage } from './audience/ParticipantProfile';
import { AuditAccessGrantsTab, AuditEventsTab, AuditIncidentsTab, AuditPage } from './audit/AuditPage';
import {
  CampaignListTab,
  CampaignReportPage,
  HypercareTab,
  NextBusinessDayTab,
  ReportsPage,
} from './reports/ReportsPage';

export const analyticsRoutes: ConsoleRoute[] = [
  {
    path: 'audience',
    handle: { permission: 'audience.segments.read', title: 'Audience' },
    element: <AudiencePage />,
    children: [
      { index: true, element: <AudienceProfilesTab /> },
      { path: 'segments', element: <AudienceSegmentsTab /> },
      { path: 'exports', element: <AudienceExportsTab /> },
      { path: 'engagement', element: <AudienceEngagementTab /> },
    ],
  },
  {
    path: 'audience/participants/:id',
    handle: { permission: 'audience.segments.read', title: 'Participant' },
    element: <ParticipantProfilePage />,
  },
  {
    path: 'audit',
    handle: { permission: 'audit.read', title: 'Audit & incidents' },
    element: <AuditPage />,
    children: [
      { index: true, element: <AuditEventsTab /> },
      { path: 'incidents', element: <AuditIncidentsTab /> },
      { path: 'access-grants', element: <AuditAccessGrantsTab /> },
    ],
  },
  {
    path: 'reports',
    handle: { permission: 'lottery.read', title: 'Reports' },
    element: <ReportsPage />,
    children: [
      { index: true, element: <NextBusinessDayTab /> },
      { path: 'hypercare', element: <HypercareTab /> },
      { path: 'campaigns', element: <CampaignListTab /> },
    ],
  },
  {
    path: 'reports/lotteries/:id',
    handle: { permission: 'lottery.read', title: 'Campaign report' },
    element: <CampaignReportPage />,
  },
];
